import type { JSX } from 'react';

import { Box, EloButton, EloIcon, Heading, Text, VStack } from '@plurall/elo-v3';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

function Unauthorized(): JSX.Element {
  const navigate = useNavigate();

  return (
    <Box
      display='flex'
      alignItems='center'
      justifyContent='center'
      minHeight='100vh'
      backgroundColor='background.primary'
      padding='space.24'>
      <VStack
        maxWidth='480px'
        width='100%'
        textAlign='center'
        gap='space.24'>
        <Box
          display='flex'
          alignItems='center'
          justifyContent='center'
          width='80px'
          height='80px'
          borderRadius='50%'
          backgroundColor='background.feedback.error'>
          <EloIcon
            icon={'not-allowed-fill'}
            color='foreground.feedback.error.primary'
            data-test-id='elo-icon'
            size='xl'
          />
        </Box>

        <VStack gap='space.8'>
          <Heading size='xl'>Acesso negado</Heading>
          <Text color='text.secondary'>Você não tem permissão para acessar esta página.</Text>
        </VStack>

        <EloButton.Brand
          aria-label='Voltar ao início'
          data-test-id='elo-brand-button'
          size='medium'
          onClick={() => void navigate({ to: '/' })}>
          Voltar ao início
        </EloButton.Brand>
      </VStack>
    </Box>
  );
}

export const Route = createFileRoute('/unauthorized')({
  component: Unauthorized,
});
